import { render, staticRenderFns } from "./ExamRadioBox.vue?vue&type=template&id=3365257a&"
import script from "./ExamRadioBox.vue?vue&type=script&lang=js&"
export * from "./ExamRadioBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/ExamRadioBox.vue"
export default component.exports